import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { useAssetsOrCodesPathname } from './useAssetsOrCodesPathname'
import { useHomeFeatureFlag } from '@dtx-company/app/containers/home/useHomeFeatureFlag'

export function useDefaultPathname(): Routes.ASSETS | Routes.CODES | Routes.HOME {
  const assetsOrCodesPathname = useAssetsOrCodesPathname()
  const homeFeatureFlag = useHomeFeatureFlag()
  return homeFeatureFlag ? Routes.HOME : assetsOrCodesPathname
}
